import { RESOURCES, FAQS } from "../data/site";
import PageHero from "../components/common/PageHero";
import SectionHeading from "../components/common/SectionHeading";
import Reveal from "../components/common/Reveal";
import CTABand from "../components/common/CTABand";
import useSeo from "../hooks/useSeo";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

export default function Resources() {
  useSeo({
    title: "Resources & Guidance",
    description:
      "Practical guidance for healthcare employers, candidates and recruitment partners, plus answers to frequently asked questions about working with Azimi & Co. Vision Recruitment.",
  });
  return (
    <>
      <PageHero
        overline="Resources"
        title="Guidance and insight for every partner"
        description="Helpful information for employers, candidates and recruitment partners — and clear answers to the questions we're asked most."
      />

      <section className="py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <SectionHeading overline="Guidance" title="Helpful resources" />
          <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {RESOURCES.map((r, i) => {
              const Icon = r.icon;
              return (
                <Reveal key={r.title} delay={(i % 4) * 70}>
                  <div className="h-full rounded-2xl border border-border bg-white p-6 shadow-sm">
                    <Icon className="h-6 w-6 text-gold" />
                    <h4 className="mt-4 font-serif text-lg text-navy">{r.title}</h4>
                    <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{r.description}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-white py-20 lg:py-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-8">
          <SectionHeading overline="FAQ" title="Frequently asked questions" />
          <Reveal className="mt-10">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-border">
                  <AccordionTrigger className="text-left font-serif text-lg text-navy hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>

      <CTABand
        title="Still have a question we haven't answered?"
        description="Our team is happy to talk through how we work — for employers, candidates and recruitment partners alike."
        primary={{ label: "Contact Our Team", to: "/contact" }}
        secondary={{ label: "Hire Talent", to: "/employers#request" }}
      />
    </>
  );
}
